import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import DashboardTable from "../../../components/dashboard-layout/table/DashboardTable";
import { columnsProduct } from "./tableConfig";
import { fetchProducts } from "../../../services/products.service";
import usePagination from "../../../hooks/usePagination";

export default function BranchProducts() {
  const { id } = useParams();
  const [branchProducts, setBranchProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    page,
    pagination,
    // itemsPerPage,
    onChangePage,
    onChangeItemsPerPage,
    // setPagination,
  } = usePagination();

  const [searchBarActiveVal, setSearchBarActiveVal] = useState("");
  const onGetBranchProducts = async () => {
    setLoading(true);
    try {
      const { data } = await fetchProducts({
        partnerBranchId: parseInt(id),
      });
      const dataOrdered = data.sort((elm) =>
        elm.status !== "DISABLED" ? -1 : 1
      );
      const formatedRows = dataOrdered.map((row) => {
        const formatData = {
          id: row?.id,
          name: row?.name,
          type: row?.type || "-",
          unitName:
            row?.commissionType === "PERCENT_PER_TOTAL"
              ? "Porcentaje"
              : "Pesos",
          comission:
            row?.commissionType === "PERCENT_PER_TOTAL"
              ? `${row?.commissionValue}%`
              : `$ ${new Intl.NumberFormat("de-DE").format(
                  row?.commissionValue
                )}`,
          active: row?.active,
          branchId: id,
          status: row?.status,
        };
        return formatData;
      });
      setBranchProducts(formatedRows);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const onChangeSearchBar = (e) => {
    setSearchBarActiveVal(e.target.value);
  };

  useEffect(() => {
    const timeout = setTimeout(() => onGetBranchProducts(), 400);

    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchBarActiveVal]);

  return (
    <>
      <DashboardTable
        columns={columnsProduct}
        tableTitle="Productos"
        data={branchProducts}
        pagination={pagination}
        onChangePage={onChangePage}
        onChangeItemsPerPage={onChangeItemsPerPage}
        page={page}
        rowKey="key"
        loading={loading}
        searchBarPlaceholder="Buscar productos"
        onChangeSearchBar={onChangeSearchBar}
        rowClassName={(record, index) => {
          return record.status === "DISABLED" ? "row-transparent" : "";
        }}
      />
    </>
  );
}
